import xhttp from 'src/utils/xhttp'
import { formHeader } from 'src/utils/form-data'

/**
 * 获取分组列表
 * @param {String} webappId
 */
export function getGroupList(params) {
    return xhttp.get('/api/dev/icon-library/folders', { params })
}

/**
 * 新增分组
 * @param {String} webappId
 * @param {String} name
 */
export function createGroup(params) {
    return xhttp.post('/api/dev/icon-library/folder', params)
}

/**
 * 修改分组名
 * @param {String} folderId
 * @param {String} name
 */
export function editGroup(params) {
    const { folderId, name } = params
    return xhttp.put(`/api/dev/icon-library/folder/${folderId}`, { name })
}

/**
 * 删除分组
 * @param {String} folderId
 * @param {String} name
 */
export function deleteGroup(folderId) {
    return xhttp.delete(`/api/dev/icon-library/folder/${folderId}`)
}

/**
 * 获取图标列表
 * @param {String} webappId
 * @param {Number} page
 * @param {Number} pageSize
 * @param {String} folderId
 */
export function getIconList(params) {
    return xhttp.get('/api/dev/icon-library/icons', { params })
}

/**
 * 删除图标
 * @param {String} ids
 */
export function deleteIcon(params) {
    return xhttp.delete('/api/dev/icon-library/icon', { params })
}

/**
 * 生成字体图标
 * @param {string} webappId
 */
export function buildIcon(params) {
    return xhttp.post('/api/dev/icon-library/generate-font', params)
}

/**
 * 获取构建状态
 * @param {string} webappId
 */
export function getBuildStatus(params) {
    return xhttp.get('/api/dev/icon-library/build-status', { params })
}

/**
 * 批量上传图标
 */
export function uploadIcons(params) {
    return xhttp.post('/api/dev/icon-library/icon', params, formHeader)
}
